module.exports = __webpack_public_path__ + "static/media/Roboto-Light.fc84e998.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Light.ttf
// module id = 551
// module chunks = 9